// @flow

type Color = string
type RGB = [number, number, number]
type RGBA = [number, number, number, number]

export const FE_BLUE = [7, 69, 128]
export const GREEN = [255, 181, 64]
export const DARK = [16, 25, 21]
export const TEXT = [31, 31, 31]
export const PRIMARY = FE_BLUE
export const SECONDARY = [205, 220, 57]
export const RED = [242, 84, 103]
export const ORANGE = [235, 175, 2]
export const CREAM = [252, 250, 228]
export const BG_COLOR = [205, 218, 230]
export const FE_BLUE_ACC = [13, 94, 168]
export const FE_BLUE_SEC = [199, 228, 255]

function rgba(color: RGB, alpha: number = 1): RGBA {
  return [...color, alpha]
}

export function colorize(color: RGB, alpha: number = 1): (alpha?: number) => Color {
  return function (alpha?: number = 1): Color {
    return `rgba(${rgba(color, alpha).join(',')})`
  }
}

export const text = colorize(TEXT)
export const primary = colorize(PRIMARY)
export const tableBG = colorize(FE_BLUE_SEC)
export const tableBGHover = colorize(FE_BLUE_ACC)
export const lightFEBlue = tableBG(0.6)
export const hoverFEBlue = tableBGHover(0.25)
export const secondary = colorize(SECONDARY)
export const dark = colorize([60, 60, 60])
export const grey = colorize([60, 60, 60])
export const white = colorize([255, 255, 255])
export const lightGrey = colorize([228, 228, 228])
export const notAsDarkGrey = colorize([145, 145, 145])
export const black = colorize([0, 0, 0])
export const lightGreen = colorize(GREEN)
export const error = colorize(RED)
export const smoke = colorize([248, 248, 248])
export const cream = colorize(CREAM)
export const orange = colorize(BG_COLOR)
export const lightRed = colorize([254, 242, 242])
